import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { I18nProvider } from './lib/i18n';
import { Home } from './pages/Home';
import { Toaster } from 'sonner';
export function App() {
  return <I18nProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="min-h-screen bg-[#FAFAFA] text-[#0A0A0F] font-sans selection:bg-violet-200 selection:text-violet-900 relative" data-id="element-2">
          <div className="bg-grain" data-id="element-3" />
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          </Routes>
          <Toaster theme="light" position="bottom-right" toastOptions={{
          style: {
            background: '#FFFFFF',
            border: '1px solid #E5E5EA',
            color: '#0A0A0F'
          }
        }} data-id="element-7" />
        </div>
      </BrowserRouter>
    </I18nProvider>;
}